"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx } from "react/jsx-runtime";
import React from "react";
import { emailService } from "../services/email_service";
import WaitingSpinner from "../components/waiting_spinner";
function closeReply(props) {
  emailService.markComplete(null, false, props.emailId).then(() => {
    props.onComplete();
  });
}
class CloseReply extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      closingReply: false
    });
  }
  render() {
    return /* @__PURE__ */ jsx(
      WaitingSpinner,
      {
        when: this.state.closingReply,
        "data-component": "CloseReply",
        children: /* @__PURE__ */ jsx(
          "button",
          {
            className: "button--progress",
            onClick: () => closeReply(this.props),
            children: "Close Reply"
          }
        )
      }
    );
  }
}
export default CloseReply;
